import { QuestionInstance } from './shared/enums/question-instance.enum';
import { GapMatchQuestion } from './models/questions/gap-match-question.model';
import { KeywordQuestion } from './models/questions/keyword-question.model';
import { ListQuestion } from './models/questions/list-question.model';
import { MultipleChoiceQuestion } from './models/questions/multiple-choice-question.model';
import { OpenQuestion } from './models/questions/open-question.model';
import { Question } from './models/questions/question.model';
import { RadioQuestion } from './models/questions/radio-question.model';
import { ReadingQuestion } from './models/questions/reading-question.model';
import { SelfExamQuestion } from './models/questions/self-exam-question.model';
import { SliderQuestion } from './models/questions/slider-question.model';
import { StarQuestion } from './models/questions/star-question.model';

export class QuestionMapper {
  private static readonly mappers: Record<string, (dto: any) => Question> = {
    [QuestionInstance.QUESTION_OPEN]: OpenQuestion.fromDto,
    [QuestionInstance.QUESTION_STAR]: StarQuestion.fromDto,
    [QuestionInstance.QUESTION_RADIO]: RadioQuestion.fromDto,
    [QuestionInstance.QUESTION_SELF_EXAM]: SelfExamQuestion.fromDto,
    [QuestionInstance.QUESTION_SLIDER]: SliderQuestion.fromDto,
    [QuestionInstance.QUESTION_MULTIPLE_CHOICE]: MultipleChoiceQuestion.fromDto,
    [QuestionInstance.QUESTION_GAP_MATCH]: GapMatchQuestion.fromDto,
    [QuestionInstance.QUESTION_LIST]: ListQuestion.fromDto,
    [QuestionInstance.QUESTION_KEYWORD]: KeywordQuestion.fromDto,
    [QuestionInstance.QUESTION_READING]: ReadingQuestion.fromDto,
  };

  public static fromDto(dto: any): Question {
    const mapper: ((dto: any) => Question) | undefined =
      QuestionMapper.mappers[dto.type];
    if (!mapper) {
      throw new Error(`Unknown question type: ${dto.type}`);
    }
    return mapper(dto);
  }
}
